import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

import { useFormErrorMessageHandler } from '@/utils/form';
import { ref, reactive } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { clearAuthTokens } from 'axios-jwt';
import { ElNotification, ElAlert } from 'element-plus';
import { required, email } from '@vuelidate/validators';

import { UpdateUserData } from '@/entities/user/types';

import {
  useGetCurrentUserQuery,
  useUpdateUserMutation,
} from '@/entities/user/hooks';
import { useForm } from '@/core/hooks/forms';

import {
  NkForm,
  NkStack,
  NkFormItem,
  NkInputText,
  NkGroup,
  NkButton,
} from '@/core/components';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserUpdateMailForm',
  emits: [],
  setup(__props, { emit }) {


const { onSubmitted } = useForm(emit);

const { t } = useI18n();
const router = useRouter();

const form = ref();

const fields = reactive({} as UpdateUserData);
const rules = {
  firstName: {
    required,
  },
  lastName: {
    required,
  },
  email: {
    email,
    required,
  },
};
const emailCopy = ref();

const {
  data: user,
  isLoading,
} = useGetCurrentUserQuery({
  refetchOnWindowFocus: false,
  onSuccess: (data) => {
    emailCopy.value = data.email;
    Object.entries(data).forEach(([key, value]) => {
      (fields as any)[key] = value;
    });
  },
});

const {
  mutateAsync,
  isError,
  isLoading: isUpdateLoading,
  error: updateUserError,
} = useUpdateUserMutation();

const { error } = useFormErrorMessageHandler(updateUserError);

const submit = () => {
  form.value.validator.$validate().then((valid: boolean) => {
    if (valid && !isUpdateLoading.value) {
      mutateAsync(
        fields,
        {
          onSuccess: async () => ElNotification({
            message: t('user.notification.email.update.message'),
            type: 'success',
            position: 'bottom-right',
          }),
        },
      ).then((data) => {
        onSubmitted(data);

        if (emailCopy.value !== fields.email) {
          clearAuthTokens();
          router.push('/login');
        }
      });
    }
  });
};

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_unref(NkForm), {
    ref_key: "form",
    ref: form,
    fields: fields,
    rules: rules
  }, {
    default: _withCtx(() => [
      (_unref(isError))
        ? (_openBlock(), _createBlock(_unref(ElAlert), {
            key: 0,
            type: "error",
            title: _unref(error)
          }, null, 8, ["title"]))
        : _createCommentVNode("", true),
      _createVNode(_unref(NkStack), null, {
        default: _withCtx(() => [
          _createVNode(_unref(NkFormItem), {
            prop: "firstName",
            label: _ctx.$t('misc.firstname')
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NkInputText), {
                modelValue: fields.firstName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fields.firstName) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_unref(NkFormItem), {
            prop: "lastName",
            label: _ctx.$t('misc.lastname')
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NkInputText), {
                modelValue: fields.lastName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fields.lastName) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_unref(NkFormItem), {
            prop: "email",
            label: _ctx.$t('profile.form.email.label')
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NkInputText), {
                modelValue: fields.email,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((fields.email) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_unref(NkGroup), { position: "right" }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_unref(NkButton), { onClick: submit }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('actions.update')), 1)
                ]),
                _: 1
              })), [
                [_directive_loading, _unref(isUpdateLoading)]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["fields"])), [
    [_directive_loading, _unref(isLoading)]
  ])
}
}

})